import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { NewsPayload, NewsService } from 'src/app/service/news/news.service';

@Component({
  selector: 'app-news-category',
  templateUrl: './news-category.component.html',
  styleUrls: ['./news-category.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewsCategoryComponent implements OnInit, OnDestroy {
  newsCategory$: Observable<any>;
  categories: any;
  activeNewsCategory: any;
  newsCategorySubscription$: Subscription;
  activeNewsCategoryCode: any;
  activeNewsCategoryName: any;
  languageSubscription$: Subscription;

  constructor(
    protected componentData: CmsComponentData<any>,
    private newsService: NewsService,
    private cmsService: CmsService,
    protected cdr: ChangeDetectorRef,
    private languageService: ShimanoLanguageService
  ) {}

  ngOnInit() {
    this.newsCategorySubscription$ = this.cmsService.getCurrentPage().subscribe((data) => {
      if (data && data.template) {
        const payload: NewsPayload = {
          fields: 'DEFAULT',
          category: 'categories',
        };
        this.newsCategory$ = this.newsService.getNews(payload);
        this.cdr.detectChanges();
      }
    });

    this.selectCategory('ALL');
  }

  selectCategory(category: string, categoryName?: string) {
    this.activeNewsCategoryCode = category;
    this.activeNewsCategoryName = categoryName;

    this.languageSubscription$ = this.languageService.getActive().subscribe(() => {
      if (this.activeNewsCategoryCode === category) {
        this.newsCategoryChange(category);
      }
    });
    this.newsService.categoryChange.next(category);
  }

  newsCategoryChange(category: string) {
    this.newsCategory$.subscribe((newsData: any) => {
      const isCategoryMatched = newsData.categories.find((newsItem: any) => newsItem.code === category);
      if (isCategoryMatched) {
        this.activeNewsCategory = isCategoryMatched;
        this.activeNewsCategoryCode = isCategoryMatched.code;
        this.activeNewsCategoryName = isCategoryMatched.name;
      }
    });
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }
  ngOnDestroy() {
    if (this.newsCategorySubscription$) {
      this.newsCategorySubscription$.unsubscribe();
    }

    if (this.languageSubscription$) {
      this.languageSubscription$.unsubscribe();
    }
  }
}
